
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class MergingGrid extends Serenity.EntityGrid<MergingRow, any> {
        protected getColumnsKey() { return 'Production.Merging'; }
        protected getDialogType() { return MergingDialog; }
        protected getIdProperty() { return MergingRow.idProperty; }
        protected getInsertPermission() { return MergingRow.insertPermission; }
        protected getLocalTextPrefix() { return MergingRow.localTextPrefix; }
        protected getService() { return MergingService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(77);

            this.editItem(<MergingRow>{
                VoucherNo: voucherNo,
                Line_No: 0,

                TransDate: now.toDateString(),
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                UserId: Q.Authorization.userDefinition.UserId,
                CurrencyId: Q.Authorization.userDefinition.CurrencyId,
                VoucherTypeId: 77

            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}